import { KEYS } from 'game/constants/SceneConstants';
import { SceneBase } from '@jollywise/jollygoodgame';
import { BACKGROUND_MUSIC, INTERACTIONS } from '../constants/Constants';

export default class Interaction extends SceneBase {
  constructor() {
    super({ key: KEYS.Interaction, active: false });
  }
  init(properties) {
    this._interactionConfig = INTERACTIONS.find((i) => i.id == properties.data.interactionId);
  }
  create() {
    super.create();

    if (this._interactionConfig.backgroundMusic) {
      this.game.soundController.playMusic(BACKGROUND_MUSIC.AMBIENT);
    } else this.game.soundController.stopMusic();
    this.subscene.events.once('shutdown', this.game.showWelcome, this.game);
    this.subscene.start(this._interactionConfig.id, {}, { pauseMainScene: true });
  }

  shutdown() {
    this.game.vo.stop();
    super.shutdown();
  }
}
